export default "__VITE_ASSET__CbtuecTC__"